const processingAttribute = 'data-direct-uploads-processing'

const disableForm = (form, submitButton) => {
  form.classList.add('active')
  form.classList.add('up-active')
  if (submitButton) {
    submitButton.classList.add('active')
    submitButton.classList.add('up-active')
    submitButton.disabled = true
  }
}
const enableForm = (form, submitButton = null) => {
  form.classList.remove('active')
  form.classList.remove('up-active')
  if (submitButton) {
    submitButton.classList.remove('active')
    submitButton.classList.remove('up-active')
    submitButton.disabled = false
  }
}

up.on('up:form:submit', 'form:has([data-direct-upload-url])', (event) => {
  const form = event.form
  const submitButton = event.submitButton

  if (form.hasAttribute(processingAttribute)) {
    // another submit is already waiting for upload
    event.preventDefault()
    return
  } else if (!form.querySelector('input[data-is-uploading]')) {
    // No uploads running, can submit normally
    return
  }

  disableForm(form, submitButton)
  form.setAttribute(processingAttribute, '')
  event.preventDefault()

  const disableListener = up.on(form, 'uploadFinished', () => {
    if (form.querySelector('input[data-is-uploading]')) {
      // another file input is still uploading.
      return
    }

    form.removeAttribute(processingAttribute)
    enableForm(form, submitButton)
    up.submit(form, { origin: submitButton })
    disableListener()
  })
})

up.on('up:form:validate', 'form:has([data-direct-upload-url])', (event) => {
  const form = event.form

  if (form.hasAttribute(processingAttribute)) {
    // submit is already running. Don't validate
    event.preventDefault()

    return
  } else if (!form.querySelector('input[data-is-uploading]')) {
    // No uploads running, can validate normally
    return
  }

  event.preventDefault()
  up.on(form, 'uploadFinished', { once: true }, () => {
    event.fields.forEach(field => {
      up.validate(field, { disable: true })
    })
  })
})
